import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const DotsSix: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <circle cx='165' cy='255' r='45' />
    <circle cx='390' cy='255' r='45' />
    <circle cx='615' cy='255' r='45' />
    <circle cx='165' cy='525' r='45' />
    <circle cx='390' cy='525' r='45' />
    <circle cx='615' cy='525' r='45' />
  </IconBase>
));

DotsSix.displayName = 'DotsSix';

export default DotsSix;
